import { apiClient } from "./ApiClient"
import {notify} from '../components/utils';


const tokenInfo = JSON.parse(sessionStorage.getItem("persist:root"));

if(tokenInfo) {
    const token = JSON.parse(tokenInfo.AdminPortal).token
    if(token) {
        apiClient.defaults.headers.Authorization = 'Bearer ' + token
    }
}
apiClient.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error?.response?.status) {
        notify("نشست شما منقضی شده است لطفا دوباره وارد شوید");
        sessionStorage.clear();
        apiClient.defaults.headers.Authorization = null;

    } else {
        return Promise.reject(error);
    }
});

export const leaderLogin = (leaderData) => apiClient.post(`/leader/transaction/V2/login`, leaderData)

export const companyRequests = (status, page, size) => apiClient.get(`/leader/transaction/V2/company/requests?status=${status}&page=${page}&size=${size}`)

export const companyRequestsSearch = (status, parameter, page, size) => apiClient.get(`/leader/transaction/V2/company/search?status=${status}&parameter=${parameter}&page=${page}&size=${size}`)

export const ReqDetail = (transactionId) => apiClient.get(`/leader/transaction/V2/request/detail/${transactionId}`)

export const updateCompanyRed = (companyData, transactionId) => apiClient.post(`/leader/transaction/V2/company/checking/${transactionId}`, companyData)

export const personalityRequests = (status, page, size) => apiClient.get(`/leader/transaction/V2/personality/requests?status=${status}&page=${page}&size=${size}`)

export const personalityRequestsSearch = (status, parameter, page, size) => apiClient.get(`/leader/transaction/V2/personality/search?status=${status}&parameter=${parameter}&page=${page}&size=${size}`)

export const canceledRequests = (status, page, size, parameter) => apiClient.get(`/leader/transaction/V2/canceled/requests?status=${status}&page=${page}&size=${size}&parameter=${parameter}`)

export const addDiscountCode = (data) => apiClient.post(`/leader/transaction/V2/discount/code/add`, data)

export const discountCodeList = (status, parameter, page, size) => apiClient.get(`/leader/transaction/V2/discount/code/search?status=${status}&parameter=${parameter}&page=${page}&size=${size}`);

export const deleteDiscountCode = (id) => apiClient.get(`/leader/transaction/V2/discount/delete?id=${id}`)

export const resetDiscountCode = (id) => apiClient.get(`/leader/transaction/V2/discount/reset?id=${id}`)

export const getDiscountCode = (id) => apiClient.get(`/leader/transaction/V2/discount/info?id=${id}`)

export const updateDiscountCode = (data, id) => apiClient.post(`/leader/transaction/V2/discount/update?id=${id}`, data)

export const canceledRequestDetail = (id) => apiClient.get(`/leader/transaction/V2/canceled/request/detail?id=${id}`)

export const canceledRequestPaid = (id) => apiClient.post(`/leader/transaction/V2/canceled/request/paid?id=${id}`)

export const doneEkyc = (id) => apiClient.post(`/leader/transaction/V2/done/ekyc?id=${id}`)

export const changeToPaid = (id) => apiClient.post(`/leader/transaction/V2/change/to/paid?id=${id}`)

export const resetEkyc = (id) => apiClient.post(`/leader/transaction/V2/reset/ekyc/count?id=${id}`)